<template>
  <highcharts ref="chart" :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'ScenarioPie',
  props: {
    ghgi: {
      type: Object,
      default: function () {
        return {}
      }
    },
    scenario: {
      type: Object,
      default: function () {
        return {}
      }
    },
    modules: {
      type: Array,
      default: function () {
        return []
      }
    },
    colors: {
      type: Object
    },
    height: {
      type: Number,
      default: 400
    },
    titleSize: {
      type: String,
      default: '18px'
    },
    exporting: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    series: function () {
      let series = []
      for (let module of this.modules) {
        let gintensity = this.ghgi.carbonSynthesis[module].intensity
        let sintensity = this.scenario.carbonSynthesis[module].intensity
        series.push({
          name: this.$t(module),
          y: gintensity - sintensity,
          color: this.colors[module]
        })
      }
      return series
    },
    intensity: function () {
      let intensity = 0
      for (let serie of this.series) {
        intensity += serie.y
      }
      return intensity
    },
    options: function () {
      const self = this
      return {
        chart: {
          type: 'pie',
          height: this.height
        },
        exporting: {
          enabled: this.exporting
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          style: {
            fontSize: this.titleSize
          },
          text: `<b>${self.$options.filters.splitNumberTons(
            Math.round(self.intensity)
          )} ${self.$t('t.co2e')} </b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: this.enabledLabels,
              formatter () {
                return `<b>${
                  this.point.name
                }:</b> ${self.$options.filters.splitNumberTons(
                  this.y
                )} ${self.$t('t.co2e')}`
              }
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: this.$t('carbon.footprint'),
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key}<br/><b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b> (${
              Math.round(this.percentage * 10) / 10
            }%)`
          }
        }
      }
    }
  }
}
</script>
